module.exports = __webpack_public_path__ + "img/1599.f3fe0f18.png";